// extracted by mini-css-extract-plugin
export default {"viewaddress":"ViewAddress_viewaddress__lPdJH","viewaddress__title":"ViewAddress_viewaddress__title__EaPXQ","viewaddress__data":"ViewAddress_viewaddress__data__Ivkcf"};